// Preserve the storage shell while React Router changes its folder parameters.
export function pageTransitionKey(pathname) {
  return /^\/storage(?:\/|$)/.test(pathname) ? '/storage' : pathname;
}
